/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsLocaleCultureString,
    ControlcenterMelcoModelsLocaleCultureStringFromJSON,
    ControlcenterMelcoModelsLocaleCultureStringFromJSONTyped,
    ControlcenterMelcoModelsLocaleCultureStringToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsLocaleString
 */
export interface ControlcenterMelcoModelsLocaleString {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsLocaleString
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsLocaleString
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsLocaleString
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsLocaleString
     */
    module?: string | null;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsLocaleCultureString>}
     * @memberof ControlcenterMelcoModelsLocaleString
     */
    strings?: Array<ControlcenterMelcoModelsLocaleCultureString> | null;
}

export function ControlcenterMelcoModelsLocaleStringFromJSON(json: any): ControlcenterMelcoModelsLocaleString {
    return ControlcenterMelcoModelsLocaleStringFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsLocaleStringFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsLocaleString {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'module': !exists(json, 'module') ? undefined : json['module'],
        'strings': !exists(json, 'strings') ? undefined : (json['strings'] === null ? null : (json['strings'] as Array<any>).map(ControlcenterMelcoModelsLocaleCultureStringFromJSON)),
    };
}

export function ControlcenterMelcoModelsLocaleStringToJSON(value?: ControlcenterMelcoModelsLocaleString | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'key': value.key,
        'source': value.source,
        'module': value.module,
        'strings': value.strings === undefined ? undefined : (value.strings === null ? null : (value.strings as Array<any>).map(ControlcenterMelcoModelsLocaleCultureStringToJSON)),
    };
}


